import { graphql } from "react-relay"

const deAuditQuery = graphql`
  query deAuditQuery($patientId: ID!, $fromDate: Date, $toDate: Date) {
    auditEvents: de_auditEvents(first: 1000, patientId: $patientId, fromDate: $fromDate, toDate: $toDate) {
      edges {
        node {
          action
          eventTime
          userName
          jsonPayload
        }
      }
    }
  }
`

export { deAuditQuery }
